export function rejectAfter<T>(
  msDelay: number,
  promise: Promise<T>,
  onTimeout?: () => void
): Promise<T> {
  // Create a promise that rejects in <msDelay> milliseconds
  const timeout: Promise<T> = new Promise((resolve, reject) => {
    const id = setTimeout(() => {
      clearTimeout(id)
      if (onTimeout) onTimeout()
      reject("Promise did not resolve after " + msDelay + "msDelay.")
    }, msDelay)
  })
  // Returns a race between our timeout and the passed in promise
  return Promise.race([promise, timeout])
}
